import WavingHandIcon from "@mui/icons-material/WavingHand";
import { Container, Link, Typography } from "@mui/material";

import { User } from "components/auth/AuthProvider";
import SectionHeader from "components/utils/SectionHeader";

const Welcome = ({ user }: { user: User }) => {
  return (
    <Container maxWidth="xl">
      <SectionHeader
        title={`Welcome, ${user?.firstName || user?.email}.`}
        icon={<WavingHandIcon />}
      />

      <Typography>
        Questions? Please refer to the{" "}
        <Link href="/docs" underline="hover" justifySelf="end">
          <b>docs</b>
        </Link>{" "}
        page for FAQ's and general troubleshooting guidelines.
      </Typography>
    </Container>
  );
};

export default Welcome;
